// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"category-posts-header_wrapper__oFX78","wrapper__title":"category-posts-header_wrapper__title__OYTtH","wrapper__view-all":"category-posts-header_wrapper__view-all__egVoV"};